import { animate, state, style, transition, trigger } from '@angular/animations';

export const FadeInOut =
  trigger('fadeInOut', [
    state('void', style({ opacity: 0 })),
    state('*', style({ opacity: 1 })),
    transition(':enter', animate('250ms ease-in')),
    transition(':leave', animate('200ms ease-out')),
  ]);
